import subscribeToPrecisionApiResponse from './Subscribers/subscribeToPrecisionApiResponse';

const connectPrecisionSubscriptions = middleware => [
    subscribeToPrecisionApiResponse(
        middleware.apiServices.precision.response$,
        middleware.state.stores.precision,
    ),
];

export default connectPrecisionSubscriptions;
